import {defineStore} from "pinia";
import api from "@/plugins/axios"

export const useServiceSettingsStore = defineStore('service-settings', {
    state: () => ({
        settings: [],
        setting: null,
    }),
    actions: {
        async getList(serviceId) {
            try {
                const {data} = await api.get(`service-settings`, {params: { serviceId }});
                this.settings = data;
                return this.settings
            } catch (error) {
                console.error(error);
            }
        },
        async create(params) {
            try {
                const {data} = await api.post(`service-settings`, params);
                return data;
            } catch (error) {
                console.error(error);
            }
        },
        async delete(id) {
            try {
                await api.delete(`service-settings/${id}`);
                return true;
            } catch (error) {
                console.error(error);
                return false;
            }
        },
    }
})